import Taro, { getCurrentInstance } from '@tarojs/taro'
import { isH5, isLatestVersion } from '@/utils/util';
import { setResError } from '@jdd/sgm-monitor';
import { LOGOUT_BASEURL, noCrypto } from '@/src/constant';
import CustomMonitor from '@/utils/custom-monitor';

const CODE_SUCCESS = '0'; // 正常返回码
const CODE_AUTHEXPIRED = 'FFP5100001'; // 需要登录｜登录过期
const CODE_REALNAMEERR = 'FFP5100046'; // 实名异常
const CODE_LOGOFF = 'FFP5100051'; // 已注销
const CODE_BOUNCE = 'FFP9000001'; // 请勿重复提交

const ERROR_SYSTEM = '数据获取失败，请稍后重试';
const ERROR_NETWORK_TIMEOUT = '连接超时，请稍后重试';
const ERROR_NETWORK_ERROR = '当前网络不可用，请检查并重试';
// const LOGIN_BASEURL = '//plogin.m.jd.com/user/login.action?appid=1100&returnurl='; // 登录链接
const LOGIN_BASEURL = '//plogin.m.jd.com/user/login.action?appid=100&kpkey=&logintype=username_login&quickreg=false&qqlogin=false&loginonestep=false&wxlogin=false&wxautologin=false&returnurl='; // 登录链接

// 绕过登录拦截的页面
const loginIgnorePages = [
  '/pages/task-hall/index', // 任务大厅
  '/pages/insure/index', // 通用-个人商业保险
]
/**
 * 获取 storage
 * @param key
 * @returns {Promise<Taro.General.CallbackResult | string>}
 */
function getStorage(key) {
  return Taro.getStorage({ key }).then(
    res => res.data
  ).catch(() => {});
}

/** 构建Header 信息 */
async function buildHeader() {
  const obj = {
    'content-type': 'application/json; char=utf-8',
    'x-requested-with': 'XMLHttpRequest',
    'accept': 'application/json',
    'cache-control': 'no-cache',
  };

  // TODO h5不用单独设置cookie，小程序需要单独设置(其他端按照差异单独处理）
  // TODO 注意：后端接口读取cookie逻辑是固定的，前端需要再各终端之间保持cookie格式一致
  if (process.env.TARO_ENV !== 'h5') {
    const cookie = await buildCookie();
    Object.assign(obj, {
      cookie,
    });
  }
  return obj;
}

/** 构建 Cookie */
async function buildCookie() {
  const { token } = getCurrentInstance().router.params;
  // TODO 可能是从插件缓存读取的
  let jdLoginKey = await getStorage('pt_key');
  // token用于测试环境
  if (!jdLoginKey) {
    jdLoginKey = token;
  }
  return appendCookie({ pt_key: jdLoginKey});
}

/**
 * 构建 cookie 对象
 * @param cookies
 * @returns {string}
 */
function appendCookie(cookies = {}) {
  let str = '';
  for (const key in cookies) {
    if (cookies[key]) {
      str = `${str + key}=${cookies[key]};`;
    }
  }
  str = str.slice(0, str.length - 1);
  return str;
}



// * 生产环境加密开关（配置生产环境开关修改此处，原则上生产需要一直为true）
const prodCrypto = true;
// * 测试环境加密开关（配置测试环境开关修改此处，不影响生产）
const devCrypto = false;
// 根据运行环境选用加密开关
const isProd = process.env.JL_ENV === 'production' ? prodCrypto : devCrypto;

export async function request(options) {
  const {
    url,
    query = {}, // 请求参数对象
    method = 'GET',
    showToast = true,
    header,
    returnUrl,
  } = options;
  const crypto = noCrypto.indexOf(url) === -1; // 如果不在非加密名单中则会进入加密流程
  const requestHeader = await buildHeader();
  Object.assign(requestHeader, header);
  let params_get = null;
  let params_post = crypto && isProd ? JSON.stringify({ datas: window.cryptico.encryptData(JSON.stringify(query)) }): JSON.stringify({ datas: query });
  return Taro.request({
    url: url,
    method: method,
    data: method === 'GET' ? params_get : params_post,
    header: requestHeader,
    credentials: 'include',
  }).then(async (response) => {
    const res = response.data;
    let code = ''; // 错误代码
    let message = ERROR_SYSTEM; // 错误信息
    let encrypCode = ''; // 响应数据加密状态 1加密 ｜ 0未加密
    let data = null; // 数据
    let backUrl = isH5 ? window.location.href : returnUrl; // 返回url
    const flag = isLatestVersion(); // 版本信息
    // 版本判断——————————————————————————————
    // 如果代码版本有更新则重新登录
    if (!flag) {
      // 退出登录
        window.location.href = `${LOGOUT_BASEURL}${encodeURIComponent(backUrl)}`;
        return;
    }
    // 加密判断及数据整理——————————————————————
    code = (res && res.code) ? String(res.code) : '';
    encrypCode = (res && res.encrypCode) ? String(res.encrypCode) : '';
    message = res && res.msg || ERROR_SYSTEM;
      // 数据未加密（不加密接口或者不加密环境）
    if (!crypto || !isProd || (crypto && encrypCode === '0')) {
      data = res.data || null;
    }
    // 数据加密（加密接口并且加密环境）
    else if ((crypto && isProd && encrypCode === '1')) {
      // 解密
      const typeData = window.cryptico.decryptData(res.data);
      // 如果解密成功
      if(typeData && typeData.status) {
        data = JSON.parse(typeData.plaintext) || null;
      } else {
        return Promise.reject('数据解析异常');
      }
    } else {
      Taro.showToast({
        title: message,
        icon: 'none',
      });
      return;
    }
    // 有效数据处理——————————————————————
    if (code === CODE_SUCCESS) { // 正常请求
      // console.log('url:', url, '\nreq:', query, '\nres:', data);
      CustomMonitor.info({ code: `success-${url}`, error: data });
      return Promise.resolve(data);
    }
    else if (code === CODE_AUTHEXPIRED) { // 登录过期
      if (!loginIgnorePages.includes(window.location.pathname)) { // 登录拦截
        // 跳转到登录页面
        window.location.href = `${LOGIN_BASEURL}${encodeURIComponent(backUrl)}`;
        return Promise.reject({ message, code });
      } else { // 登录绕过
        return Promise.resolve({
          isLogin: false,
        });
      }
    }
    // 实名异常
    else if (code === CODE_REALNAMEERR) {
      window.location.href = `${LOGOUT_BASEURL}${encodeURIComponent(backUrl)}`;
      return Promise.reject({ message, code });
    }
    // 重复提交接口
    else if (code === CODE_BOUNCE) {
      return Promise.reject({ message, code });
    }
    // 账号已注销
    else if (code === CODE_LOGOFF) {
      // 跳转注销提示页
      window.location.href = `${window.location.origin}/pages/tip-account-invalid/index`;
      // return Promise.reject({ message, code });
    }
    else { // 其他错误情况
      return Promise.reject({ message, code });
    }
  }).catch((err) => {
    // console.log('接口异常!', '\nurl:', url, '\nreq:', query, '\nerr:', err)
    let message = err.message || err.errMsg || ERROR_SYSTEM;
    let code = (err && err.code) ? String(err.code) : '';
    if (message === 'request:fail timeout') {
      // 超时问题
      message = ERROR_NETWORK_TIMEOUT;
      CustomMonitor.error({ code: 'http_error', msg: '接口超时', error: err });
    } else if (/request fail/.test(message) || /request:fail/.test(message)) {
      // 网络问题
      CustomMonitor.error({ code: 'http_error', msg: '网络错误', error: err });
      message = ERROR_NETWORK_ERROR;
    } else {
      // 其他业务异常
      CustomMonitor.error({ code: 'api_error', msg: '业务异常', error: err });
    }
    if (showToast) {
      Taro.showToast({
        title: message,
        icon: 'none',
        duration: 3000,
      });
    }
    return Promise.reject(setResError({ message, code, ...err }));
  });
}
